const filterButtonClass = (active, activeClass, inactiveClass = 'bg-wine-dark text-gray-400 hover:text-white hover:bg-wine-dark/80') =>
  `px-4 py-2 rounded-full text-sm font-semibold transition-all duration-300 ${active ? activeClass : inactiveClass}`;

const WineFilters = ({
  classificationFilter,
  setClassificationFilter,
  grapeFilter,
  setGrapeFilter,
  priceRange,
  setPriceRange,
  sortOrder,
  setSortOrder,
  availableGrapes,
  priceRanges,
  isGrapeCategory,
  isPriceCategory,
}) => (
  <div className="mb-8 bg-gradient-to-br from-[#2a2535] to-[#1a1625] rounded-2xl p-6 border border-gray-700/50">
    <div className="space-y-6">
      <div>
        <label className="block text-wine-gold text-sm font-semibold mb-3 uppercase tracking-wide">
          Filtrar por Tipo:
        </label>
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={() => setClassificationFilter('todos')} className={filterButtonClass(classificationFilter === 'todos', 'bg-wine-gold text-wine-dark')}>
            Todos
          </button>
          <button type="button" onClick={() => setClassificationFilter('tinto')} className={filterButtonClass(classificationFilter === 'tinto', 'bg-red-900 text-red-200')}>
            Tintos
          </button>
          <button type="button" onClick={() => setClassificationFilter('branco')} className={filterButtonClass(classificationFilter === 'branco', 'bg-yellow-100 text-yellow-800')}>
            Brancos
          </button>
          <button type="button" onClick={() => setClassificationFilter('rosé')} className={filterButtonClass(classificationFilter === 'rosé', 'bg-pink-200 text-pink-800')}>
            Rosés
          </button>
        </div>
      </div>

      {!isPriceCategory && (
        <div className={isGrapeCategory ? 'bg-gradient-to-r from-purple-900/30 via-purple-800/20 to-purple-900/30 rounded-2xl p-6 -m-6 border-2 border-purple-500/50 shadow-lg shadow-purple-500/20' : ''}>
          <label className="block text-wine-gold text-sm font-semibold uppercase tracking-wide mb-3">
            🍇 Filtrar por Uva:
          </label>
          <div className="flex flex-wrap gap-2">
            <button type="button" onClick={() => setGrapeFilter('todas')} className={filterButtonClass(grapeFilter === 'todas', 'bg-wine-gold text-wine-dark')}>
              Todas
            </button>
            {availableGrapes.map((grape) => (
              <button
                key={grape}
                type="button"
                onClick={() => setGrapeFilter(grape)}
                className={filterButtonClass(
                  grapeFilter === grape,
                  'bg-purple-600 text-white scale-110',
                  isGrapeCategory
                    ? 'bg-purple-900/50 text-purple-200 hover:bg-purple-600 hover:text-white hover:scale-105'
                    : 'bg-wine-dark text-gray-400 hover:text-white hover:bg-wine-dark/80'
                )}
              >
                {grape}
              </button>
            ))}
          </div>
        </div>
      )}

      {!isGrapeCategory && (
        <div className={isPriceCategory ? 'bg-gradient-to-r from-green-900/30 via-emerald-800/20 to-green-900/30 rounded-2xl p-6 -m-6 border-2 border-green-500/50 shadow-lg shadow-green-500/20' : ''}>
          <label className="block text-wine-gold text-sm font-semibold uppercase tracking-wide mb-3">
            💰 Faixa de Preço:
          </label>
          <div className="flex flex-wrap gap-2">
            {priceRanges.map((range) => (
              <button
                key={range.id}
                type="button"
                onClick={() => setPriceRange(range.id)}
                className={filterButtonClass(
                  priceRange === range.id,
                  'bg-green-600 text-white scale-110',
                  isPriceCategory && range.id !== 'todos'
                    ? 'bg-green-900/50 text-green-200 hover:bg-green-600 hover:text-white hover:scale-105'
                    : 'bg-wine-dark text-gray-400 hover:text-white hover:bg-wine-dark/80'
                )}
              >
                {range.icon && <span className="mr-1">{range.icon}</span>}
                {range.label}
              </button>
            ))}
          </div>
        </div>
      )}

      <div>
        <label className="block text-wine-gold text-sm font-semibold mb-3 uppercase tracking-wide">
          Ordenar por:
        </label>
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={() => setSortOrder('nome')} className={filterButtonClass(sortOrder === 'nome', 'bg-wine-gold text-wine-dark')}>
            A-Z
          </button>
          <button type="button" onClick={() => setSortOrder('preco-asc')} className={filterButtonClass(sortOrder === 'preco-asc', 'bg-wine-gold text-wine-dark')}>
            💰 Menor Preço
          </button>
          <button type="button" onClick={() => setSortOrder('preco-desc')} className={filterButtonClass(sortOrder === 'preco-desc', 'bg-wine-gold text-wine-dark')}>
            💎 Maior Preço
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default WineFilters;
